import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, ReactNode } from 'react';
import SlidingPane from 'react-sliding-pane';
import useAutoFocus from 'src/hooks/useAutoFocus';
import useRemoveScrollbar from 'src/hooks/useRemoveScrollbar';

interface SidePanelProps {
  children?: ReactNode;
  title?: string;
  isOpen: boolean;
  position?: 'left' | 'right' | 'bottom';
  width?: string;
  onClose: () => void;
  className?: string;
  overlayClassName?: string;
  titleClassName?: string;
  closeOnEsc?: boolean;
}

const SidePanel: FC<SidePanelProps> = ({
  children,
  isOpen,
  position,
  width,
  onClose,
  title,
  className,
  overlayClassName,
  titleClassName,
  closeOnEsc = true,
}) => {
  useRemoveScrollbar(isOpen);
  const closeButtonRef = useAutoFocus(isOpen, [title, isOpen]);
  return (
    <SlidingPane
      className={className}
      overlayClassName={`${overlayClassName} z-[100]`}
      isOpen={isOpen}
      from={position}
      width={width}
      hideHeader={true}
      onRequestClose={onClose}
      shouldCloseOnEsc={closeOnEsc}
    >
      {title && (
        <div className={`flex items-center mb-5 justify-between ${titleClassName}`}>
          <span className="font-bold">{title}</span>
          <button
            className="k-button k-button-md k-button-flat k-button-flat-base k-rounded-md k-icon-button k-window-action k-dialog-action"
            onClick={onClose}
            ref={closeButtonRef}
          >
            {<FontAwesomeIcon icon={faXmark} />}
          </button>
        </div>
      )}
      {children}
    </SlidingPane>
  );
};

export default SidePanel;
